import Icon from "@ant-design/icons";
import { ReactComponent as Box } from "themes/icons/box.svg";
import { ReactComponent as Location } from "themes/icons/location.svg";
import { ReactComponent as Vi } from "themes/icons/vi.svg";
import { ReactComponent as Us } from "themes/icons/us.svg";

export function LocationOutlined() {
  return <Icon component={Location} />;
}

export function BoxOutlined() {
  return <Icon component={Box} />;
}

export function ViIcon() {
  return <Icon component={Vi} />;
}

export function EnIcon() {
  return <Icon component={Us} />;
}

export const LanguageIcons: { [key: string]: JSX.Element } = {
  "en-us": EnIcon(),
  vi: ViIcon(),
};
